import Vue from 'vue'
import Vuex from 'vuex'
// import apiClient from '@/services/axios'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    carts: [],
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
    ADD_CART_ITEM(state, payload) {
      state.carts = [...state.carts, payload]
      localStorage.setItem('myCarts', JSON.stringify(state.carts))
    },
    SET_SELECTED_STATUS_CART_ITEM(state, payload) {
      console.log('payload', payload)
      const cart = state.carts.find(cart => cart.key === payload.key)

      if (cart) {
        cart.isSelected = payload.isSelected
      }
      localStorage.setItem('myCarts', JSON.stringify(state.carts))
    },
    REMOVE_CART_ITEM(state, key) {
      const idx = state.carts.findIndex(cart => cart.key === key)
      if (idx !== -1) {
        state.carts.splice(idx, 1)
      }
      console.log(state.carts)
      localStorage.setItem('myCarts', JSON.stringify(state.carts))
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
    totalCartPrice(state) {
      let total = 0
      const carts = state.carts
      if (carts.length) {
        carts.forEach(cart => {
          if (cart.isSelected) {
            total += cart.price
          }
        })
      }

      return total
    },
  },
}
